module.exports = __webpack_public_path__ + "static/img/1_9.c2c78d44.jpg";